import { apiGet, apiPost, apiPut } from "./base";

interface FetchFeedbacksOptions {
  signal?: AbortSignal;
}

export const fetchFeedbacksForPatientEncounter = async (
  patientId: string | number,
  encounterId: string | number,
  options: FetchFeedbacksOptions = {}
) => {
  const { signal } = options;
  const url = `/api/feedback/?patient_id=${patientId}&encounter_recording_id=${encounterId}`;
  const response = await apiGet(url, signal);

  let next = response.data?.next;

  while (next) {
    if (signal?.aborted) {
      break;
    }
    const nextResponse = await apiGet(next, signal);
    response.data?.results?.push(...nextResponse.data?.results);
    next = nextResponse.data?.next;
  }

  return response.data?.results;
};

export const addFeedback = async (data: any) => {
  const url = `/api/feedback/`;
  const response = await apiPost(url, data);
  return response.data;
};

export const updateFeedback = async (feedbackId: string | number, data: any) => {
  const url = `/api/feedback/${feedbackId}/`;
  const response = await apiPut(url, data);
  return response.data;
};
